import type { ReactNode } from 'react'

export function Switch({
  checked,
  onChange,
  disabled = false,
  label,
  description,
  compact = false,
  className = '',
}: {
  checked: boolean
  onChange: (next: boolean) => void
  disabled?: boolean
  label: string
  description?: ReactNode
  /** Μόνο το toggle — το label περνάει στο aria-label */
  compact?: boolean
  className?: string
}) {
  const toggle = (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-block h-7 w-12 shrink-0 rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-zinc-900 ${
        checked ? 'bg-violet-600' : 'bg-zinc-300 dark:bg-zinc-600'
      } ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
    >
      <span
        className={`pointer-events-none absolute top-1 left-1 block h-5 w-5 rounded-full bg-white shadow transition-transform duration-200 ease-out ${
          checked ? 'translate-x-5' : 'translate-x-0'
        }`}
      />
    </button>
  )

  if (compact) return toggle

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {toggle}
      <div>
        <p className="text-sm font-medium text-zinc-700 dark:text-zinc-300">{label}</p>
        {description ? (
          <div className="mt-1 space-y-1 text-sm text-zinc-600 dark:text-zinc-400">
            {description}
          </div>
        ) : null}
      </div>
    </div>
  )
}
